import DefaultProps from '../../commonTypes/defaultprops.types';
import Handler from '../../commonTypes/handler.types';

export enum Elevation {
  SUBTLE = 'subtle',
  MEDIUM = 'medium',
  PROMINENT = 'prominent',
  NONE = 'none'
};

export interface CardProps extends DefaultProps {
  elevation?: Elevation;
  handlers?: Handler;
  hideIfEmpty?: boolean;
}

export interface WrapperProps extends Omit<CardProps, 'elevation' | 'hideIfEmpty'> {
  $elevation?: Elevation;
  $hideIfEmpty?: boolean;
}
